export default {
    computed: {
        touchDotStyle() {
            return {
                top: `${this.touchPosition.y}px`,
                left: `${this.touchPosition.x}px`,
                position: 'absolute',
            };
        },
        previousBallPositions() {
            // Get the current batter's ID
            const currentBatter = this.atbat();
            // Filter positions for the current batter from previous innings
            return this.posArr.filter(pos => pos.playerId === currentBatter.id && pos.position.x !== "0.0000" && pos.position.y !== "0.0000" && this.admin);
        },
    },
    methods: {
        registerTouch(event) {
            if (!this.admin) return false
            const touch = event.touches[0];
            // Get the touch coordinates relative to the image
            const imageElement = event.target;
            const rect = imageElement.getBoundingClientRect();
            const x = touch.clientX - rect.left; // X-coordinate
            const y = touch.clientY - rect.top;  // Y-coordinate
            this.touchPosition = {x, y};
            // this.showTouch = true;  // Show the red dot after a touch
        },
        normalizePosition(x, y) {
            // Get the image element
            const image = document.querySelector('img[alt="bb5-field"]');

            if (image) {
                // Get the current width and height of the image
                const fieldWidth = image.clientWidth;
                const fieldHeight = image.clientHeight;
                // Calculate the normalized position relative to the image dimensions
                const normalizedX = (x * 100 / fieldWidth);
                const normalizedY = (y * 100 / fieldHeight);
                return {x: normalizedX.toFixed(4), y: normalizedY.toFixed(4)};
            } else {
                // Fallback in case image is not found (should not happen if image is loaded properly)
                return {x: 0, y: 0};
            }
        },
        saveBallPosition(action) {
            if (!this.admin) return
            const player = this.atbat();
            const normalizedTouchPosition = this.normalizePosition(this.touchPosition.x, this.touchPosition.y);

            // Save the normalized position
            this.posArr.push({
                playerId: player.id,
                inning: this.game.inning,
                action: action,
                position: normalizedTouchPosition,
            });
        },
        calculatePosition(normalizedX, normalizedY , offset = 0) {
            const image = document.querySelector('img[alt="bb5-field"]');
            const parent = image.parentElement;

            const style = getComputedStyle(parent);
            const widthWithoutPadding = parent.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);

            if (image) {
                // Get the current width and height of the image
                const fieldWidth = widthWithoutPadding;
                const fieldHeight = widthWithoutPadding;

                // Convert normalized values back to pixel values
                const x = Math.round((normalizedX * fieldWidth / 100) - offset);
                const y = Math.round((normalizedY * fieldHeight / 100) - offset);
                return {x: x, y: y};
            } else {
                return {x: 0, y: 0};
            }
        },
    }
}